import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./mainLayout";
import { DEFAULT_LANG } from "./utils/i18n";
import OnboardingProtectedRoute from "./components/OnboardingProtectedRoute";
import OnboardingFlowRoute from "./components/OnboardingFlowRoute";
import HomeRedirect from "./components/HomeRedirect";
import GuestRoute from "./components/GuestRoute";
import SignupPage from "./pages/SignupPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import LoginPage from "./pages/LoginPage";
import GoogleAuthCallbackPage from "./pages/GoogleAuthCallbackPage";
import OnboardingPage from "./pages/OnboardingPage";
import TranscriptionPage from "./pages/TranscriptionPage";
import TranscriptEditorPage from "./pages/TranscriptEditorPage";
import ProjectsLayout from "./pages/ProjectsLayout";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import SettingsPage from "./pages/SettingsPage";

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/signup" element={<Navigate to={`/signup/${DEFAULT_LANG}`} replace />} />
          <Route
            path="/signup/:lang"
            element={
              <GuestRoute>
                <SignupPage />
              </GuestRoute>
            }
          />
          <Route path="/verify-email" element={<Navigate to={`/verify-email/${DEFAULT_LANG}`} replace />} />
          <Route
            path="/verify-email/:lang"
            element={
              <GuestRoute>
                <VerifyEmailPage />
              </GuestRoute>
            }
          />
          <Route path="/login" element={<Navigate to={`/login/${DEFAULT_LANG}`} replace />} />
          <Route
            path="/login/:lang"
            element={
              <GuestRoute>
                <LoginPage />
              </GuestRoute>
            }
          />
          <Route path="/auth/google/callback" element={<GoogleAuthCallbackPage />} />
          <Route path="/onboarding" element={<Navigate to={`/onboarding/${DEFAULT_LANG}`} replace />} />
          <Route
            path="/onboarding/:lang"
            element={
              <OnboardingFlowRoute>
                <OnboardingPage />
              </OnboardingFlowRoute>
            }
          />
          <Route
            path="/transcribe"
            element={
              <OnboardingProtectedRoute>
                <TranscriptionPage />
              </OnboardingProtectedRoute>
            }
          />
          <Route
            path="/transcribe/:id"
            element={
              <OnboardingProtectedRoute>
                <TranscriptEditorPage />
              </OnboardingProtectedRoute>
            }
          />
          <Route
            path="/caption/:id"
            element={
              <OnboardingProtectedRoute>
                <TranscriptEditorPage />
              </OnboardingProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <OnboardingProtectedRoute>
                <SettingsPage />
              </OnboardingProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <OnboardingProtectedRoute>
                <ProjectsLayout />
              </OnboardingProtectedRoute>
            }
          >
            <Route index element={<ProjectsPage />} />
            <Route path=":id" element={<ProjectDetailPage />} />
          </Route>
          <Route path="/__preview/transcribe" element={<TranscriptionPage />} />
          <Route path="/__preview/transcribe/:id" element={<TranscriptEditorPage />} />
          <Route path="/__preview/caption/:id" element={<TranscriptEditorPage />} />
          <Route path="/__preview/settings" element={<SettingsPage />} />
          <Route path="/__preview/projects" element={<ProjectsLayout />}>
            <Route index element={<ProjectsPage />} />
            <Route path=":id" element={<ProjectDetailPage />} />
          </Route>
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;
